import { render, staticRenderFns } from "./discount_detail.vue?vue&type=template&id=35a39ba6&scoped=true"
import script from "./discount_detail.vue?vue&type=script&lang=js"
export * from "./discount_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a39ba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a39ba6')) {
      api.createRecord('35a39ba6', component.options)
    } else {
      api.reload('35a39ba6', component.options)
    }
    module.hot.accept("./discount_detail.vue?vue&type=template&id=35a39ba6&scoped=true", function () {
      api.rerender('35a39ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_goods/form/discount_detail.vue"
export default component.exports